import { Pipe, PipeTransform } from '@angular/core';
import {
  AbstractControl,
  FormArray, FormGroup, Validators
} from '@angular/forms';

@Pipe({ name: 'isFormFieldRequired' })
export class IsFormFieldRequiredPipe implements PipeTransform {
  transform(
    form: FormGroup | FormArray | null,
    formControl?: AbstractControl
  ): boolean {
    if (form) {
      return form?.hasValidator(Validators.required)
      || Object
        .values(form.controls)
        .some((control) => control.hasValidator(Validators.required)
          || control.hasValidator(Validators.requiredTrue));
    } if (formControl) {
      return formControl.hasValidator(Validators.required)
        || formControl.hasValidator(Validators.requiredTrue);
    }
    return false;
  }
}
